export enum TelegramBotTab {
  SETTINGS = 'settings',
  DROP = 'drop',
}
